import { PromoBanner } from './PromoBanner';

export default PromoBanner
